var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: { name: "slide-fade" },
      on: { "before-leave": _vm.beforeLeave, "after-leave": _vm.afterLeave }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShow,
              expression: "isShow"
            }
          ],
          staticClass: "toast",
          on: { click: _vm.hideToast }
        },
        [
          _c("div", { staticClass: "main" }, [
            _vm.type
              ? _c(
                  "div",
                  {
                    staticClass: "icon-box",
                    attrs: { flex: "main:center cross:center" }
                  },
                  [
                    _c("i", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.type === "succeed",
                          expression: "type==='succeed'"
                        }
                      ],
                      staticClass:
                        "iconfont icon-ic_select_simple font30 orange2"
                    })
                  ]
                )
              : _vm._e(),
            _c("div", { staticClass: "text" }, [
              _vm._v(" " + _vm._s(_vm.text) + " ")
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }